<template>
  <div class="p-1">Selecciona una conversa</div>
</template>

<script>
export default {};
</script>

<style></style>
